import { TApplicationState } from '../../types/redux';

export function getGALabel(state: TApplicationState) {
  const {
    newbuilding: { gaLabel },
  } = state;

  return gaLabel;
}
